import { render, staticRenderFns } from "./SntpConfig.vue?vue&type=template&id=69bba0e4&"
import script from "./SntpConfig.vue?vue&type=script&lang=js&"
export * from "./SntpConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports